import React, { Fragment } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  CardActionArea,
  Button,
} from "@mui/material";
import { useQuery } from "react-query";
import { getSimulationsData } from "../../services/cluster";
import { grey } from "@mui/material/colors";
import ClusterSimulationFileUploadDialog from "./ClusterSimulationFileUploadDialog";
import InfoTile from "../common/InfoTile";
import DottedTile from "../common/DottedTile";

const ClusterImageStats = () => {
  const { data: { data: { simulations = 0 } = {} } = {} } = useQuery(
    ["getSimulationsReport", { simulationType: "CLUSTER" }],
    getSimulationsData,
    {
      refetchOnWindowFocus: false,
    }
  );

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    width: 800,
    height: 400,
    bgcolor: "background.paper",
    outline: 0,
    p: 4,
  };

  return (
    <Fragment>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} >
        <InfoTile title={"Total Clusters"} info={simulations || "0"} />
      </Grid>
    </Fragment>
  );
};

ClusterImageStats.defaultProps = {};

ClusterImageStats.propTypes = {};

export default ClusterImageStats;
